<template>
  <div>
    <!-- <ModalAccount v-if="accountList" ref="ModalAccount" :account="accountList" @action="selectAccount"></ModalAccount> -->
    <modalcart v-model="dialog" />
    <v-snackbar v-model="alert.show" timeout="2000" multi-line right top :color="alertColor">
      <v-layout column>
        <div v-html="alert.message"></div>
      </v-layout>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="hideAlert">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-app-bar flat app height="90" light class="header-frame bg-hwi-3">
      <div class="pr-3" id="brand-bar">
        <template v-if="store_slug == ''">
          <router-link to="/" class="d-none d-sm-block d-xs-none">
            <v-img 
              contain
              class="img-logo fill-height"
              src="/assets/icons/logo-hwi.png"
              height="60"
              max-width="auto"
              width="auto"
              light
              position="left center"
            ></v-img>
          </router-link>
          <router-link to="/" class="d-block d-sm-none d-xs-block small-logo">
            <v-img
              class="img-logo"
              width="100%"
              cover
              src="/assets/icons/logo-gram-hwi-green.png"
            ></v-img>
          </router-link>
        </template>

        <template v-else>
          <router-link :to="'/' + store_slug + '/'" class="d-none d-sm-block d-xs-none">
            <v-img 
              contain
              class="img-logo fill-height"
              src="/assets/icons/logo-hwi.png"
              height="60"
              max-width="auto"
              width="auto"
              light
              position="left center"
            ></v-img>
          </router-link>
          <router-link :to="'/' + store_slug + '/'" class="d-block d-sm-none d-xs-flex align-center justify-center small-logo">
            <v-img
              class="img-logo"
              width="100%"
              height="100%"
              cover
              position="center center"
              src="/assets/icons/logo-gram-hwi-green.png"
            ></v-img>
          </router-link>
        </template>
      </div>

      <div id="feature-bar">
        <v-col class="mt-0 px-0 px-md-3 d-none d-sm-block" id="search-bar">
          <v-form @submit.prevent="cari" role="form">
            <v-text-field
              dark
              flat
              v-model="search_text"
              hide-details
              placeholder="Ketik pencarian di sini"
              append-icon="mdi-magnify"
              solo-inverted
              dense
              class="rounded-lg text-caption text-sm-body-2"
              @click:append="cari"
            ></v-text-field>
          </v-form>
        </v-col>

        <div class="pl-2 pr-2 d-block d-xs-block d-sm-none" id="mini-search-bar">
          <v-btn
            fab
            x-small
            class="mt-md-n2 bg-transparent"
            elevation="0"
            @click="searchDrawer = true"
          >
            <!-- <v-img width="20" src="/assets/icons/search-icon.svg"></v-img> -->
            <v-icon class="text-h5 white--text">mdi-magnify</v-icon>
          </v-btn>
        </div>

        <div class="pl-2 pr-2 d-sm-block" id="cart-bar" v-if="local_store_slug != '' && local_store_slug.length > 0">
          <router-link :to="'/' + store_slug + '/cart'">
            <v-btn fab x-small class="mt-md-n2 bg-transparent" elevation="0">
              <v-img width="20" src="/assets/icons/shopping-cart.svg"></v-img>
            </v-btn>
            <div class="red rounded-xl badge-cart" v-if="cartData.length > 0">
              <div class="white--text text-center font-size-13 font-weight-bold">
                <!-- {{ cartProduk(cartData) }} -->
                {{ cartData.length }}
              </div>
            </div>
          </router-link>
        </div>

        <div class="pl-2 pr-2 mr-1 d-sm-block" id="message-bar" v-if="false">
          <v-btn fab x-small class="mt-md-n2 bg-transparent" elevation="0">
            <v-img width="20" src="/assets/icons/kirim-pesan.svg"></v-img>
          </v-btn>
        </div>

        <template v-if="local_store_slug !== '' && local_store_slug.length > 0">
          <v-menu
            dark
            open-on-hover
            close-on-click
            close-on-content-click
            offset-y
            class="d-none d-sm-block d-xs-none pl-2"
            id="user-bar"
            v-if="isAuth"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                v-bind="attrs"
                v-on="on"
                class="mt-md-n2 px-0 bg-transparent"
                id="userbtn-bar"
                elevation="0"
              >
                <div class="font-weight-bold">
                  <span class="d-none d-sm-block d-xs-none pl-2">
                    {{ userData ? userData.buyer_username : "" }}
                  </span>
                  <div class="d-block d-sm-none d-xs-block">
                    <v-img width="24" src="/assets/icons/user-no-pading.svg"></v-img>
                  </div>
                </div>
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list dark color="white">
              <v-list-item link @click.native="gotoProfile">
                <v-icon class="pr-3 grey--text text--darken-1">mdi-account</v-icon>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-2"
                    >Profil</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item link @click.native="gotoPesan" v-if="local_store_slug">
                <v-icon class="pr-3 grey--text text--darken-1">mdi-email-outline</v-icon>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-2"
                    >Pesan</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <!-- <v-list-item
                link
                @click.native="gotoMyStore"
                v-if="['seller', 'stockist'].includes(userData.user_type)"
              >
                <span class="pr-2 ml-n1">
                  <v-img width="32" src="/assets/icons/icon-toko.svg"></v-img>
                </span>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-2"
                    >Toko Saya</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item> -->
              <v-list-item link @click.native="gotoTransaction">
                <span>
                  <v-icon class="pr-3 grey--text text--darken-1"
                    >mdi-format-list-bulleted</v-icon
                  >
                </span>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-1"
                    >Transaksi</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <!-- <v-list-item link @click.native="changeAccount" v-if="accountList">
                <v-icon class="pr-3 grey--text text--darken-1">mdi-account-details-outline</v-icon>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-2"
                    >Ganti Akun</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item> -->
              <v-list-item link @click.native="onLogout">
                <v-icon class="pr-3 grey--text text--darken-1">mdi-exit-to-app</v-icon>
                <v-list-item-content>
                  <v-list-item-title class="grey--text text--darken-2"
                    >Logout</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <template v-else>
            <v-menu
              dark
              open-on-hover
              close-on-click
              close-on-content-click
              offset-y
              id="unauthuser-bar"
            >
              <!-- class="d-none d-sm-none d-xs-block" -->
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  text
                  v-bind="attrs"
                  v-on="on"
                  class="mt-md-n2 px-0 bg-transparent d-block d-sm-none d-xs-block"
                  id="userbtn-bar"
                  elevation="0"
                >
                  <div class="font-weight-bold">
                    <div class="d-block d-sm-none d-xs-block">
                      <v-img width="24" src="/assets/icons/user-no-pading.svg"></v-img>
                    </div>
                  </div>
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list dark color="white">
                <v-list-item>
                  <v-list-item-content>
                    <router-link
                      :to="{ name: 'login' }"
                      text
                      class="mt-md-n2 px-0 text-deco"
                    >
                      <v-btn outlined color="primary">
                        <div class="font-weight-bold primary--text">
                          <span class="text-capitalize">Masuk</span>
                        </div>
                      </v-btn>
                    </router-link>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <router-link
                      :to="{ name: 'register' }"
                      text
                      class="mt-md-n2 px-0 text-deco"
                    >
                      <v-btn outlined color="grey">
                        <div class="font-weight-bold">
                          <span class="text-capitalize">Daftar</span>
                        </div>
                      </v-btn>
                    </router-link>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>

            <div class="d-none d-xs-none d-sm-flex" id="user-bar">
              <router-link :to="{ name: 'login' }" text class="mt-md-n2 px-0 text-deco">
                <v-btn text color="white">
                  <div class="font-weight-bold">
                    <span class="text-capitalize pr-1">Masuk</span>
                  </div>
                </v-btn>
              </router-link>
              <v-divider vertical class="mt-md-n2" color="white"></v-divider>
              <router-link
                :to="{ name: 'register' }"
                text
                class="ml-3 mt-md-n2 px-0 text-deco"
              >
                <v-btn outlined color="white">
                  <div class="font-weight-bold">
                    <span class="text-capitalize pr-1">Daftar</span>
                  </div>
                </v-btn>
              </router-link>
            </div>
          </template>
        </template>

        <v-app-bar-nav-icon
          dark
          @click="drawer = true"
          class="d-xs-block d-sm-none d-none"
        ></v-app-bar-nav-icon>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      right
      floating
      id="menu-drawer-bar"
      v-if="false"
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ userData ? userData.user_name : "" }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-cart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Keranjang</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="searchDrawer"
      app
      left
      floating
      width="100%"
      id="search-drawer-bar"
    >
      <v-form @submit.prevent="cari" role="form" class="py-0 px-3">
        <v-text-field
          flat
          background-color="white"
          v-model="search_text"
          hide-details
          placeholder="Ketik pencarian di sini"
          class="black--text text-caption text-sm-body-2"
          height="40"
        >
          <v-icon
            slot="prepend-inner"
            color="black"
            class="font-weight-bold p-3"
            @click="clearSearch"
          >
            mdi-arrow-left
          </v-icon>
          <v-icon slot="append" class="primary--text font-weight-bold p-3" @click="cari">
            mdi-magnify
          </v-icon>
        </v-text-field>
      </v-form>

      <h5 class="my-2 pt-3 px-3" v-if="false">PENCARIAN POPULER</h5>
      <v-list nav dense v-if="false">
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-title>HP Canggih Cek</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Jamu Langsing</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Masker Kain</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
// import ModalAccount from '@/views/store/login/ModalChooseAccount'

export default {
  components: {
    // ModalAccount
  },
  data() {
    return {
      drawer: false,
      searchDrawer: false,
      dialog: false,
      timer: null,
      lastChange: null,
      cartData: [],
      detailStore: {},
      store_slug: '',
      local_store_slug: ''
    };
  },
  watch: {
    $route (val){
      if (val.name !== 'search-product') {
        this.search_text = ''
      } else if (!val.query.search) {
        this.search_text = ''
      }

      if (val.name !== 'home-store' || val.name !== 'home' || val.name !== 'product-detail') {
        this.getStoreDetail()
      }

      setTimeout(() => {
        let store = localStorage.getItem('HwiEcomStore')

        this.store_slug = (store == undefined) ? '' : store
        let allowedPath = ['transaction', 'checkout', 'profile', 'product', 'seller', 'login-seller', 'reset-password-seller']
        if (this.store_slug !== '') {
          if (this.store_slug == this.$route.params.slug) {
            this.local_store_slug = this.$route.params.slug
          } else {
            if (allowedPath.includes(this.$route.params.slug) || this.$route.params.slug == undefined) this.local_store_slug = this.store_slug
          }
        }
        
      }, 1000);
    },

    store_slug(val) {
      let cart = JSON.parse(localStorage.getItem('hwiecom-cart'))
      let cartData = (cart == undefined) ? [] : cart
      let cartStore = ''

      if (cartData.length > 0) cartStore = cartData[0].store_slug

      setTimeout(() => {
        if (val !== cartStore) localStorage.removeItem('hwiecom-cart')
      }, 10);
    }
  },
  computed: {
    ...mapState('auth', ['isAuth', 'userData']),
    ...mapState(['alert']),
    // ...mapState('cart', ['cartData']),

    alertColor() {
      switch (this.alert.type) {
        case 'success':
          return 'primary';
        case 'warning':
          return 'yellow';
        default:
          return 'red';
      }
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapMutations(['hideAlert']),
    ...mapMutations('auth', ['success']),
    // ...mapActions('cart', ['getCart']),
    // ...mapMutations('cart', ['setCart']),

    async getStoreDetail() {
			if (this.$route.params.slug !== undefined) {
        let allowedPath = ['transaction', 'checkout', 'profile', 'product', 'seller', 'login-seller', 'reset-password-seller']
        await this.$http
          .get(`/store/detail-store/${this.$route.params.slug}`, {
            // ...this.apiHeaders
          })
          .then((res) => {
            const data = res.data.data
            this.detailStore = data
            
            if (Object.keys(data).length > 0) localStorage.setItem('HwiEcomStore', this.$route.params.slug)
            let store = localStorage.getItem('HwiEcomStore')
            this.store_slug = (store == undefined) ? '' : store
            if (allowedPath.includes(this.$route.params.slug) || this.$route.params.slug == undefined) this.local_store_slug = this.store_slug
            if (this.store_slug == this.$route.params.slug) {
              this.local_store_slug = this.$route.params.slug
            }
          })
          .catch(() => {
            // err = error
            // console.log(error.response.data.message)
            
            this.store_slug = ''
            localStorage.removeItem('HwiEcomStore')
            let allowedPath = ['transaction', 'checkout', 'profile', 'product', 'seller', 'login-seller', 'reset-password-seller']
            if (!allowedPath.includes(this.$route.params.slug)) {
              this.$router.push("/").catch(() => {});
            }
          })
      }
		},

    changeAccount() {
      this.$refs.ModalAccount.modalShow()
    },
    selectAccount(data) {
      this.success(data)
      location.reload();
    },
		wdrawer() {
			if (window.matchMedia("(min-width: 600px)").matches) {
				this.drawer = false;
			}
		},
		gotoProfile() {
			// this.$router.push({
			// 	name: "profile",
			// });
      window.location.replace(window.location.origin + '/profile');
		},
    gotoPesan() {
      window.location.replace(window.location.origin + '/inbox');
    },
		gotoMyStore() {
			let routeData = this.$router.resolve({name:"seller-dashboard"})
			window.open(routeData.href, '_blank');
		},
		gotoTransaction() {
			// this.$router.push("/transaction/list").catch(() => {});
      window.location.replace(window.location.origin + '/transaction/list');
		},
		onLogout() {
			this.logout().then(() => {
				// this.$router.push({
				// 	name: "login",
				// });
        window.location.replace(window.location.origin + '/login');
			});
		},
		cari() {
			if (this.search_text) {
				let link = this.search_text
				.toString()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toLowerCase()
				.trim()
				.replace(/\s+/g, '-')
				.replace(/[^\w-]+/g, '')
				.replace(/--+/g, '-')
				// this.$router.push(`/store/${this.store_slug}/${link}`);
        window.location.href = window.location.origin + `/store/${this.store_slug}/${link}`
			}
		},
		clearSearch() {
			this.searchDrawer = false;
		},
		cartProduk() {
			// let count = 0
			// data.forEach( (el) => {
			// 	el.cart_detail.forEach( () => {
			// 		count += 1
			// 	});
			// });
			// return count
		}
	},
	created() {
		setTimeout(() => {
      let store = localStorage.getItem('HwiEcomStore')
      let allowedPath = ['transaction', 'checkout', 'profile', 'product', 'seller', 'login-seller', 'reset-password-seller']
      
      this.store_slug = (store == undefined) ? '' : store
      if (this.store_slug !== '') {
        // console.log(this.store_slug + ' == ' + this.$route.params.slug)
        if (this.store_slug == this.$route.params.slug) {
          this.local_store_slug = this.$route.params.slug
        } else {
          if (this.$route.params.name !== 'home-store' || this.$route.params.name !== 'home' || this.$route.params.name !== 'product-detail') {
            this.getStoreDetail()
          }
          if (allowedPath.includes(this.$route.params.slug)) this.local_store_slug = this.store_slug
          if (this.$route.params.slug == undefined) this.local_store_slug = this.store_slug
        }

      }
    }, 1000);
    
    let cart = JSON.parse(localStorage.getItem('hwiecom-cart'))
    this.cartData = (cart == undefined) ? [] : cart
		window.addEventListener("resize", this.wdrawer);

    let curVal = localStorage.getItem('hwiecom-cart');
    this.lastChange = new Date()
    this.timer = setInterval(() => {
      const newVal = localStorage.getItem('hwiecom-cart');
      if (newVal !== curVal) {
        curVal = newVal;
        if (newVal == undefined) {
          this.lastChange = new Date()
          this.cartData = []
        } else {
          this.lastChange = new Date()
          this.cartData = JSON.parse(newVal)
        }
      }
    }, 1000);

	},
	destroyed() {
		window.removeEventListener("resize", this.wdrawer);
	},
  beforeDestroy() {
    clearInterval(this.timer)
  }
};
</script>

<style lang="scss" scoped>
#feature-bar {
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: auto;
  padding-left: 25px;
}

.small-logo {
  background: #fff;
  width: 40px;
  height: 40px;
  padding: 6px 8px;
  border-radius: 4px;

  .v-image {
    display: block;
    margin: 0 auto;
  }
}

#mini-search-bar {
  .v-image {
    .v-image__image {
      background-size: 20px !important;
    }
  }
}

#search-drawer-bar {
  display: none;
}

@media (max-width: 599px) {
  #cart-bar,
  #message-bar,
  #mini-search-bar {
    padding-left: 7px !important;
    padding-right: 7px !important;
  }
  #search-drawer-bar {
    display: flex;
  }
}
</style>
